import { StyledTable } from 'pages/Settings/NotificationSubscriptions/NotificationTriggerTable';
import { InfoPopup } from 'shared/info_popup/InfoPopup';

export function DeskNotificationTriggerTable({
    rows,
    /**
     * Waiting on mobile support, say as much!
     */
    pushNotYetAvailable = false,
}: {
    rows: JSX.Element[];
    pushNotYetAvailable?: boolean;
}) {
    return (
        <StyledTable>
            <thead>
                <tr>
                    <th>Notification Properties</th>
                    <th>Email</th>
                    <th>
                        Push{' '}
                        {pushNotYetAvailable && (
                            <InfoPopup title="Why disabled?">
                                Push notifications will be available in a future
                                SMARTdiagnostics release!
                            </InfoPopup>
                        )}
                    </th>
                </tr>
            </thead>
            <tbody>{rows}</tbody>
        </StyledTable>
    );
}
